/** @format */

export const TELEGRAM_SUPPORT_URL = 'https://t.me/adsensor_amocrm_bot';
